// Existing features parent product can enable/disable
export var ALLOWED_FEATURES = {
  view: ['byline-contributors', 'byline-extensions', 'delete', 'edit', 'inline-comments', 'page-comments', 'page-reactions', 'sticky-header', 'disable-login-flow', 'disable-share'],
  edit: ['delete-draft', 'disable-login-flow', 'template-browser']
};
export var DEFAULT_ALLOWED_FEATURES = {
  view: ['byline-contributors', 'byline-extensions', 'page-comments', 'page-reactions'],
  edit: []
};